const req = require.context('@ws-utils', true, /routes\.js$/);
let customRoutesAll = [];
req.keys().forEach(key => {
  const mod = req(key);
  if (Array.isArray(mod.default)) {
    customRoutesAll = customRoutesAll.concat(mod.default);
  }
});
export { customRoutesAll };